// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 20:19:34

export default {
  "id": "oil-tanker-transport-truck",
  "slug": "oil-tanker-transport-truck",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/d0776351a85944e6b2b7aede6cb19683-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/d0776351a85944e6b2b7aede6cb19683/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Oil Tanker Transport Truck",
      "description": "Let's go on to ride with an oil tanker transporter truck across all the continents like the Euro, Asia, and America oil transporter truck game has real features in the Euro and American cargo systems of the fuel truck. ",
      "instructions": "Use W,A,S,D for player movement.",
      "genres": [
        ".IO",
        "Simulation"
      ],
      "tags": [
        "city",
        "offroad",
        "transport",
        "travel",
        "truck"
      ]
    },
    "zh-CN": {
      "title": "油轮运输卡车",
      "description": "让我们驾驶油罐运输卡车穿越所有大陆，就像欧洲、亚洲和美洲的油罐运输卡车游戏一样，这款游戏具有真实的欧洲和美国燃料卡车货运系统特点。",
      "instructions": "使用W、A、S、D键进行玩家移动。",
      "genres": [
        ".IO",
        "模拟"
      ],
      "tags": [
        "城市",
        "越野",
        "交通",
        "旅行",
        "卡车"
      ]
    },
    "zh-TW": {
      "title": "油罐車運輸卡車",
      "description": "讓我們開始乘著油罐運輸卡車穿越所有大陸，就像歐洲、亞洲和美國的油罐運輸卡車遊戲一樣，本遊戲具有實際的歐洲和美國燃料卡車貨運體系功能。",
      "instructions": "使用 W,A,S,D 鍵控制角色移動。",
      "genres": [
        ".IO",
        "模擬"
      ],
      "tags": [
        "城市",
        "越野",
        "交通",
        "旅行",
        "卡車"
      ]
    },
    "zh-HK": {
      "title": "石油輸送油罐車",
      "description": "我哋一齊開油輪運輸卡車，橫跨歐洲、亞洲和美洲，就像歐洲、亞洲及美洲油輸運輸卡車遊戲一樣，遊戲具有真實的歐洲和美國燃料卡車貨運系統特色。",
      "instructions": "用W、A、S、D按鍵操控角色移動。",
      "genres": [
        ".IO",
        "模擬"
      ],
      "tags": [
        "城市",
        "越野",
        "交通",
        "旅行",
        "卡車"
      ]
    },
    "ja": {
      "title": "石油タンカー輸送トラック",
      "description": "ヨーロッパ、アジア、アメリカの石油輸送トラックゲームのように、全ての大陸を横断するための石油タンカー輸送トラックで乗りましょう。このゲームは、燃料トラックのヨーロッパとアメリカの貨物システムに実在の機能を持っています。",
      "instructions": "W,A,S,Dを使用してプレイヤーの移動を行ってください。",
      "genres": [
        ".IO",
        "シミュレーション"
      ],
      "tags": [
        "都市",
        "オフロード",
        "交通",
        "旅行",
        "トラック"
      ]
    },
    "ko": {
      "title": "기름 탱커 운송 트럭",
      "description": "유로, 아시아, 아메리카 오일 운반 트럭 게임처럼 모든 대륙을 across all the continents like the Euro, Asia, and America oil transporter truck game has real features in the Euro and American cargo systems of the fuel truck. 오일 탱커 운반 트럭으로 여행해 보세요.",
      "instructions": "W,A,S,D 키를 사용하여 플레이어 이동하세요.",
      "genres": [
        ".IO",
        "시뮬레이션"
      ],
      "tags": [
        "도시",
        "오프로드",
        "운송",
        "여행",
        "트럭"
      ]
    },
    "fr": {
      "title": "Pétrolier transporteur camion",
      "description": "Allons continuer à conduire un camion-citerne transporteur de pétrole à travers tous les continents, comme dans le jeu Euro, Asie et Amérique transporteur de pétrole. Le jeu Euro et Amérique possède des fonctionnalités réelles dans les systèmes de fret des camions-citernes de carburant.",
      "instructions": "Utilisez les touches W, A, S, D pour le déplacement du joueur.",
      "genres": [
        ".IO",
        "Simulation"
      ],
      "tags": [
        "ville",
        "tout-terrain",
        "transport",
        "voyage",
        "camion"
      ]
    }
  }
};
